import { FormattedMessage } from 'react-intl';

import styles from './UnlinkAccountModal.module.css';
import ConfirmationButton from '../../../ui/confirmationButton/ConfirmationButton';
import { Prompt } from '../../../ui/prompt/index';

export const UnlinkAccountModal = ({
    unlinkingLinkedAccountName,
    accountUnlinkingInProgress,
    unlinkingLinkedAccountStatus,
    onConfirm,
    closeModal
}: {
    unlinkingLinkedAccountName: string | null;
    accountUnlinkingInProgress: boolean;
    unlinkingLinkedAccountStatus: 'success' | 'error' | null;
    onConfirm: () => void;
    closeModal: () => void;
}) => {
    return (
        <div
            data-testid="unlink-account-modal"
            className={styles.UnlinkAccountModal}
        >
            <h3>
                <FormattedMessage
                    id="_.trading_data.unlink_account_modal.title"
                    defaultMessage="Are you sure you'd like to unlink your {bankName} account?"
                    values={{ bankName: unlinkingLinkedAccountName }}
                />
            </h3>
            <p>
                <FormattedMessage
                    id="_.trading_data.unlink_account_modal.sub_title"
                    defaultMessage="Unlinking a bank will remove all of the accounts that you hold with that bank from your iwoca account."
                />
            </p>
            <Prompt>
                <button onClick={closeModal}>
                    <FormattedMessage
                        id="_.trading_data.unlink_account_modal.cancel"
                        defaultMessage="Cancel"
                    />
                </button>
                <ConfirmationButton
                    data-testid="confirm-unlink-account"
                    onClick={onConfirm}
                    loading={accountUnlinkingInProgress}
                    status={unlinkingLinkedAccountStatus}
                >
                    <FormattedMessage
                        id="_.trading_data.unlink_account_modal.unlink"
                        defaultMessage="Unlink"
                    />
                </ConfirmationButton>
            </Prompt>
        </div>
    );
};
